import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import OnboardingShell from './shared/OnboardingShell';
import LegalReviewContent from './shared/LegalReviewContent';

const TermsReacceptanceGate = () => {
  const { currentUser, acceptCurrentTerms } = useAuth();
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [legalState, setLegalState] = useState({
    canAccept: false,
  });

  const termsStatus = currentUser?.terms_status;

  const handleAccept = async () => {
    setLoading(true);
    setSubmitError('');

    try {
      const result = await acceptCurrentTerms();
      if (!result.success) {
        setSubmitError(result.error || 'Failed to accept the latest Terms of Use.');
      }
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div className="welcome-onboarding__footer">
      <div className="welcome-onboarding__footer-actions">
        <button
          type="button"
          className="btn btn-primary welcome-onboarding__primary"
          onClick={handleAccept}
          disabled={loading || !legalState.canAccept}
        >
          {loading ? 'Accepting...' : 'Accept and continue'}
        </button>
      </div>
    </div>
  );

  return (
    <OnboardingShell centerStage footer={footer} brandLabel="GrabTime Welcome">
      <div className="onboarding-auth">
        <div className="onboarding-auth__header">
          <span className="onboarding-auth__eyebrow">Updated terms</span>
          <h1 className="onboarding-auth__title">Updated Terms of Use required.</h1>
          <p className="onboarding-auth__copy">
            Review and accept GrabTime Terms {termsStatus?.active_version || ''} to continue using the app.
          </p>
        </div>

        {submitError && (
          <Alert variant="danger" className="onboarding-auth__status">
            {submitError}
          </Alert>
        )}

        <LegalReviewContent onStateChange={setLegalState} />
      </div>
    </OnboardingShell>
  );
};

export default TermsReacceptanceGate;
